export default {
  MAX_DISTANCE: 25000,
  setDistance (userLocation, coordinates) {
    let coords = coordinates.split(',')
    return this.getDis(userLocation.lat, userLocation.lng, parseFloat(coords[0]), parseFloat(coords[1]))
  },
  getDis (lat1, lng1, lat2, lng2) {
    const earthRadiusKm = 6371

    const dLat = toRadian(lat2 - lat1)
    const dLng = toRadian(lng2 - lng1)

    lat1 = toRadian(lat1)
    lat2 = toRadian(lat2)

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(lat1) * Math.cos(lat2)
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    return (earthRadiusKm * c) * 1000
  },
  readableDistance (distEnabled, distLoading, rDist) {
    let realDist = (rDist / 1000).toFixed(2)
    if (distEnabled && !distLoading && realDist < 1000) {
      let dist = realDist


      if (dist < 1) {
        return ' - ' + dist * 1000 + ' m'
      }

      return ' - ' + dist + ' km'
    }

    return ''
  }
}

function toRadian (degree) {
  return degree * (Math.PI / 180)
}



// WEBPACK FOOTER //
// ./src/components/dashboard/stations/util/distance.js